import { render, staticRenderFns } from "./ConfirmaDelecaoModal.vue?vue&type=template&id=991d1c68&scoped=true&lang=pug"
import script from "./ConfirmaDelecaoModal.vue?vue&type=script&lang=js"
export * from "./ConfirmaDelecaoModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmaDelecaoModal.vue?vue&type=style&index=0&id=991d1c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991d1c68",
  null
  
)

export default component.exports